import React, { ReactElement, useCallback, useState } from 'react';
import cx from 'clsx';
import Select, { SelectProps } from 'antd/es/select';
import { IconRcSolidTriangle } from '@/assets/common';
// 坑，机构号里AntDesign版本为4.x，这里需要引入一份css，没办法像主站一样共用一份
import 'antd/es/select/style/index.css';

import style from './index.module.scss';

export const AntdSelect = (props: SelectProps & { children: ReactElement | ReactElement[] }) => {
  const { onDropdownVisibleChange } = props;
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const handleDropdownVisibleChange = useCallback(
    open => {
      setDropdownVisible(open);
      onDropdownVisibleChange?.(open);
    },
    [onDropdownVisibleChange],
  );

  return (
    <Select
      onDropdownVisibleChange={handleDropdownVisibleChange}
      suffixIcon={
        <IconRcSolidTriangle className={cx(style.dropdownIcon, dropdownVisible && style.reverse)} />
      }
      {...props}
    />
  );
};

AntdSelect.Option = Select.Option;
AntdSelect.OptGroup = Select.OptGroup;
